import {RegisterValues,GuestValues} from '@/forms/Register'
import axios from '@/utils/axios'
const Registeration = async (
  values: RegisterValues & {referral: string | null},
) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/register',
    values,
  )
  return data
}
const GuestSigning = async (
  values: GuestValues & {referral: string | null},
) => {
  const payload = {
    name: values.name,
    email: values.email,
    phone: values.phone,
    country_code: values.country_code
  };
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/guest/session',
    payload,
  )
  if (data && data.token) {
    localStorage.setItem('auth_token', data.token);
  }
  return data
}
const GuestConvert = async (values: GuestValues) => {
  const { data } = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/guest/convert',
    values,
  );
  return data;
};
const SignIn = async (data: {email: string; password: string}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/login', data)
}

const Verification = async (data: {
  verification_code: string
  country_code: string
  number: string
  email: string
}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/verification', data)
}

const ResendVerificationEmail = async (email: string) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/resend_email', 
  { email: email }
)
}

const ResendVerification = async (phone: {
  country_code: string
  number: string
}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/resend', {
    country_code: phone.country_code,
    number: phone.number,
  })
}

const ResendWhatsappVerification = async (data: {
  country_code: string
  number: string
  locale: string | undefined
}) => {
  await axios.post(process.env.NEXT_PUBLIC_API_URL + '/resend_whatsapp', 
    {
      country_code: data.country_code,
      number: data.number,
      locale: data.locale
    }
  )
}

const ForgotPassword = async (phone: {country_code: string; phone: string}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/forgot', {
    country_code: phone.country_code,
    phone: phone.phone,
  })
}

const ForgotPasswordEmail = async (phone: {
  country_code: string
  phone: string
}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/forgot_email', {
    country_code: phone.country_code,
    phone: phone.phone,
  })
}

const ForgotPasswordWhatsapp = async (phone: {
  country_code: string
  phone: string
}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/forgot_whatsapp', {
    country_code: phone.country_code,
    phone: phone.phone,
  })
}

const PasswordReset = async (data: {
  country_code: string
  phone: string
  forgot_code: string
  password: string
}) => {
  return await axios.post(process.env.NEXT_PUBLIC_API_URL + '/pass/reset', data)
}
export {
  Registeration,
  SignIn,
  Verification,
  ResendVerification,
  ResendVerificationEmail,
  ForgotPassword,
  ForgotPasswordEmail,
  PasswordReset,
  ResendWhatsappVerification,
  ForgotPasswordWhatsapp,
  GuestSigning,
  GuestConvert
}
